// BookingStep2.jsx – Select Available Room
import { useBooking } from '../context/BookingContext';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import './BookingStep.css';

export default function BookingStep2() {
  const { bookingData, setBookingData } = useBooking();
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {

      if (!bookingData.checkInDate || !bookingData.checkOutDate) {
    console.warn('No booking data, redirecting...');
    navigate('/booking/step1');
    return;
  }

    const fetchAvailableRooms = async () => {
  try {
    const res = await axios.get('https://websitecasagloria.onrender.com/api/rooms/available', {
    //const res = await axios.get('http://localhost:5000/api/rooms/available', {
      params: {
        checkIn: bookingData.checkInDate,
        checkOut: bookingData.checkOutDate,
        guests: bookingData.guests
      }  
    });

    console.log('Full response:', res);
    console.log('res.data:', res.data);

    // ✅ Ensure rooms is always an array
    if (Array.isArray(res.data)) {
      setRooms(res.data);
    } else if (res.data?.rooms && Array.isArray(res.data.rooms)) {
      setRooms(res.data.rooms); // in case backend wraps rooms
    } else {
      setRooms([]); // fallback when no rooms available
    }

  } catch (err) {
    console.error(err);
    setError('Failed to load available rooms.');
    setRooms([]); // also fallback on error
  } finally {
    setLoading(false);
  }
};


    fetchAvailableRooms();
  }, [bookingData, navigate]);

  const handleSelect = (room) => {
    setBookingData({ ...bookingData, selectedRoom: room });
    navigate('/booking/step3');
  };

    if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
        <p>Cargando habitaciones...</p>
      </div>
    );
  }
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="step-container">
      <br /><br />
      <h2>Step 2: Select a Room</h2>
     
  {/* Progress Bar */}
      <div className="progress-bar">
        <div className="progress-fill" style={{
      width: '40%'
    }}></div>
      </div>

      <div className="room-list">
        
        {rooms.length === 0 ? (
      <p>No rooms available for these dates.</p>
    ) : (rooms.map((room) => (
          <div key={room._id} className="room-card">
            <img src={room.images[0]} alt={room.name} className="room-image" />
            <h3>{room.name}</h3>
            <p>{room.description}</p>
            <p><strong>Price:</strong> ${room.price*(1-(4-bookingData.guests)*0.08)} / night</p>
            <p><strong>Capacity:</strong> {room.capacity} guests</p>
            <button onClick={() => handleSelect(room)}>Select</button>
          </div>
        )))}
      </div>
    </div>
  );
}
